export default __webpack_public_path__ + "static/media/timeTracking.b3484118.svg";